// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"textarea_wrapper__NUm_X","textarea":"textarea_textarea__AZJJD"};